// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var TailwindMerge = require("tailwind-merge");
var JsxRuntime = require("react/jsx-runtime");

function Loader(props) {
  var __flexGrow = props.flexGrow;
  var __size = props.size;
  var __loadingText = props.loadingText;
  var loadingText = __loadingText !== undefined ? __loadingText : "Loading";
  var size = __size !== undefined ? __size : "medium";
  var flexGrow = __flexGrow !== undefined ? __flexGrow : false;
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("svg", {
                            children: [
                              JsxRuntime.jsx("polygon", {
                                    className: "animate-loader-top",
                                    fill: "#1b3549",
                                    points: "23,9 28,0 29,0 34,9"
                                  }),
                              JsxRuntime.jsx("polygon", {
                                    className: "animate-loader-middle-top",
                                    fill: "#b8b8b8",
                                    points: "15,21 20,13 37,13 42,21"
                                  }),
                              JsxRuntime.jsx("polygon", {
                                    className: "animate-loader-middle-bottom",
                                    fill: "#b8b8b8",
                                    points: "8,34 12,26 45,26 49,34"
                                  }),
                              JsxRuntime.jsx("polygon", {
                                    className: "animate-loader-bottom",
                                    fill: "#b8b8b8",
                                    points: "0,48 5,39 52,39 56,48"
                                  })
                            ],
                            className: "w-14 h-12 mx-auto",
                            height: "56",
                            width: "48",
                            viewBox: "0 0 56 48"
                          }),
                      size === "mini" ? null : JsxRuntime.jsx("div", {
                              children: loadingText,
                              className: "text-zinc-500 text-base uppercase tracking-widest font-medium text-center mt-4"
                            })
                    ],
                    className: "inline-flex justify-center flex-col"
                  }),
              className: TailwindMerge.twMerge([
                    "flex justify-center items-center",
                    size === "large" ? "scale-[2]" : (
                        size === "medium" ? "scale-100" : (
                            size === "small" ? "scale-50" : "scale-[0.25]"
                          )
                      ),
                    flexGrow ? "grow" : ""
                  ])
            });
}

var make = Loader;

var $$default = Loader;

exports.make = make;
exports.default = $$default;
exports.__esModule = true;
/* tailwind-merge Not a pure module */
